module.exports = __webpack_public_path__ + "img/stars.04f29898.svg";